import {Controller} from "stimulus"
import Modal from "./modal_controller"
import EventEmitter from "../utils/EventEmitter";

export default class extends Modal {

    static targets = [
    ]

    beforeOpened(e) {
        const index = e.detail.index
        EventEmitter.emit(`slider-index-changed-${this.name}`, {index})
    }

    afterClosed(e) {
    }

}